import React from 'react';
import { ListItem, Checkbox, FormControlLabel, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { referToLoBypassEnabled, showTransKeysEnabled } from 'app/actions';
import * as DevToolActions from 'app/actions/dev-tool/actions';
import { withTranslation } from 'react-i18next';
import { storage } from 'app/util/storage';

const languageOptions = [
  { label: 'Select Language', value: {} },
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'French (unsupported)', value: 'fr' },
];

class DevGlobalOpts extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl            : null,
      bypassLoanOfficer   : props.bypassLoanOfficer,
      selectedIndex       : 0,
      selectedLanguage    : this.props.i18n.language,
      showLocalizationKeys: props.showLocalizationKeys,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.checked,
    });
  };

  handleClickListItem = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  setSelectedLanguage = (value: any) => {
    /* Change the value in local storage to the value selected by the dev tool */
    if (!this.state.showLocalizationKeys) {
      this.props.i18n.changeLanguage(value).then(() => {
        storage.local.setItem('i18nextLng', value);
      });
    }
  };

  handleMenuItemClick = (event, index) => {
    this.setState({
      selectedIndex   : index,
      anchorEl        : null,
      selectedLanguage: languageOptions[index].value,
    });
    this.setSelectedLanguage(languageOptions[index].value);
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  componentDidUpdate(prevProps, prevState) {
    /* Dispatch toggle refer to loan officer bypass */
    if (this.state.bypassLoanOfficer !== prevState.bypassLoanOfficer) {
      this.props.toggleReferToLoBypass(this.state.bypassLoanOfficer);
    }

    if (this.state.showLocalizationKeys !== prevState.showLocalizationKeys) {
      if (this.state.showLocalizationKeys) {
        this.props.i18n.changeLanguage('cimode').then(() => {
          storage.local.setItem('i18nextLng', 'cimode');
        });
      } else {
        this.props.i18n.changeLanguage(this.state.selectedLanguage).then(() => {
          storage.local.setItem('i18nextLng', this.state.selectedLanguage);
        });
      }
    }
  }

  render() {
    const { bypassLoanOfficer, showLocalizationKeys, anchorEl } = this.state;
    return (
      <React.Fragment>
        <ListItem
          button
          aria-haspopup = "true"
          aria-controls = "lock-menu"
          aria-label    = "Translation Language"
          onClick       = {this.handleClickListItem}
        >
          <ListItemText
            primary   = "Change Translation Language"
            secondary = {languageOptions[this.state.selectedIndex].label}
          />
        </ListItem>
        <Menu
          id       = "lock-menu"
          anchorEl = {anchorEl}
          open     = {Boolean(anchorEl)}
          onClose  = {this.handleClose}
        >
          {languageOptions.map((option, index) => {
            return (
              <MenuItem
                disabled = {index === 0}
                key      = {option.label}
                onClick  = {(event) => this.handleMenuItemClick(event, index)}
                selected = {index === this.state.selectedIndex}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
        <ListItem>
          <FormControlLabel
            label   = "Show Localization Keys"
            control = {
              <Checkbox
                checked  = {showLocalizationKeys}
                onChange = {this.handleChange('showLocalizationKeys')}
                value    = "showLocalizationKeys"
              />
            }
          />
        </ListItem>
        <ListItem>
          <FormControlLabel
            label   = "Refer to MLO Bypass"
            control = {
              <Checkbox
                checked  = {bypassLoanOfficer}
                onChange = {this.handleChange('bypassLoanOfficer')}
                value    = "bypassLoanOfficer"
              />
            }
          />
        </ListItem>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bypassLoanOfficer   : referToLoBypassEnabled(),
    showLocalizationKeys: showTransKeysEnabled(),
  };
};

const mapDispatchToProps = DevToolActions;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(DevGlobalOpts));
